"use strict";

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = require("lodash");

var client_1 = require("./client");
/**
 * Map with short names for each of the requester maker functions. Used in
 * makeClientConstructor
 * @private
 */


var requesterFuncs = {
  unary: client_1.Client.prototype.makeUnaryRequest,
  server_stream: client_1.Client.prototype.makeServerStreamRequest,
  client_stream: client_1.Client.prototype.makeClientStreamRequest,
  bidi: client_1.Client.prototype.makeBidiStreamRequest
};
/**
 * Creates a constructor for a client with the given methods, as specified in
 * the methods argument. The resulting class will have an instance method for
 * each method in the service, which is a partial application of one of the
 * [Client]{@link grpc.Client} request methods, depending on `requestSerialize`
 * and `responseSerialize`, with the `method`, `serialize`, and `deserialize`
 * arguments predefined.
 * @param methods An object mapping method names to
 *     method attributes
 * @param serviceName The fully qualified name of the service
 * @param classOptions An options object.
 * @return New client constructor, which is a subclass of
 *     {@link grpc.Client}, and has the same arguments as that constructor.
 */

function makeClientConstructor(methods, serviceName, classOptions) {
  if (!classOptions) {
    classOptions = {};
  }

  var ServiceClientImpl =
  /*#__PURE__*/
  function (_client_1$Client) {
    _inherits(ServiceClientImpl, _client_1$Client);

    function ServiceClientImpl() {
      _classCallCheck(this, ServiceClientImpl);

      return _possibleConstructorReturn(this, _getPrototypeOf(ServiceClientImpl).apply(this, arguments));
    }

    return ServiceClientImpl;
  }(client_1.Client);

  _.each(methods, function (attrs, name) {
    var methodType; // TODO(murgatroid99): Verify that we don't need this anymore

    if (_.startsWith(name, '$')) {
      throw new Error('Method names cannot start with $');
    }

    if (attrs.requestStream) {
      if (attrs.responseStream) {
        methodType = 'bidi';
      } else {
        methodType = 'client_stream';
      }
    } else {
      if (attrs.responseStream) {
        methodType = 'server_stream';
      } else {
        methodType = 'unary';
      }
    }

    var serialize = attrs.requestSerialize;
    var deserialize = attrs.responseDeserialize;

    var methodFunc = _.partial(requesterFuncs[methodType], attrs.path, serialize, deserialize);

    ServiceClientImpl.prototype[name] = methodFunc; // Associate all provided attributes with the method

    _.assign(ServiceClientImpl.prototype[name], attrs);

    if (attrs.originalName) {
      ServiceClientImpl.prototype[attrs.originalName] = ServiceClientImpl.prototype[name];
    }
  });

  ServiceClientImpl.service = methods;
  return ServiceClientImpl;
}

exports.makeClientConstructor = makeClientConstructor;
/**
 * Load a gRPC package definition as a gRPC object hierarchy.
 * @param packageDef The package definition object.
 * @return The resulting gRPC object.
 */

function loadPackageDefinition(packageDef) {
  var result = {};

  for (var serviceFqn in packageDef) {
    if (packageDef.hasOwnProperty(serviceFqn)) {
      var service = packageDef[serviceFqn];
      var nameComponents = serviceFqn.split('.');
      var serviceName = nameComponents[nameComponents.length - 1];
      var current = result;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = nameComponents.slice(0, -1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var packageName = _step.value;

          if (!current[packageName]) {
            current[packageName] = {};
          }

          current = current[packageName];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      current[serviceName] = makeClientConstructor(service, serviceName, {});
    }
  }

  return result;
}

exports.loadPackageDefinition = loadPackageDefinition;